// extracted by mini-css-extract-plugin
module.exports = {"wrap":"adminPage_wrap__12k_c","form":"adminPage_form__31Ij3"};